import { render, staticRenderFns } from "./BriqueChart.vue?vue&type=template&id=66134746&"
import script from "./BriqueChart.js?vue&type=script&lang=js&"
export * from "./BriqueChart.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports